"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsumeSoulsAbilityHandler = exports.ConsumeSoulsActorAbilityFactory = exports.ConsumeSoulsAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const enums_1 = require("../../core/enums");
const core_1 = require("../../core/effects/core");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class ConsumeSoulsAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ConsumeSouls;
        this.__typeName = "ConsumeSouls";
    }
}
exports.ConsumeSoulsAbilityArgs = ConsumeSoulsAbilityArgs;
let ConsumeSoulsActorAbilityFactory = class ConsumeSoulsActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ConsumeSouls", "AllAllies", 0);
    }
};
ConsumeSoulsActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ConsumeSouls")
], ConsumeSoulsActorAbilityFactory);
exports.ConsumeSoulsActorAbilityFactory = ConsumeSoulsActorAbilityFactory;
let ConsumeSoulsAbilityHandler = class ConsumeSoulsAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const deathSequence = sequence.pushSequence("parallel");
        let totalHealing = 0;
        for (const soulId of container.getActor(ability.invokerId).companionIds) {
            totalHealing += container.getAttributeScore(soulId, enums_1.AttributeType.Health);
            container.applyEffect(deathSequence, ability.invokerId, soulId, new core_1.DeathEffectArgs());
        }
        const healingSequence = sequence.pushSequence("parallel");
        const increaseAttributesBy = Math.round(0.5 * container.getLevel(ability.invokerId));
        const livingAllies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies);
        const incrementalHealing = Math.round(totalHealing / livingAllies.length);
        for (const allyId of livingAllies) {
            container.applyBuff({
                sequence: healingSequence,
                creatorId: ability.invokerId,
                targetId: allyId,
                duration: Duration_1.Duration.Turns(3),
                effect: new core_1.LinkedEffectsEffectArgs([enums_1.AttributeType.Power, enums_1.AttributeType.Focus].map(attribute => new core_1.MaxAttributeIncreaseEffectArgs(attribute, increaseAttributesBy)), false),
                onApplied: (sequence) => {
                    container.applyHealing({
                        sequence,
                        healerId: ability.invokerId,
                        targetId: allyId,
                        amount: incrementalHealing,
                        onApplied: sequence => sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(allyId, "feet"), "DivineBubble"))
                    });
                }
            });
        }
    }
};
ConsumeSoulsAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ConsumeSouls)
], ConsumeSoulsAbilityHandler);
exports.ConsumeSoulsAbilityHandler = ConsumeSoulsAbilityHandler;
